import React from 'react';
import { Button } from '@chakra-ui/react';
import { TextFlexRowWithChildren } from '@atoms/TextFlexRowWithChildren';

type T = {
  bold: string;
  text: string;
  buttonText: string;
  onClick: any;
  isTruncated?: boolean;
  ariaLabel?: string;
};

export const TextRowWithButton = ({
  bold,
  text,
  buttonText,
  onClick,
  isTruncated,
  ariaLabel,
}: T) => {
  const isButtonShowing = buttonText !== undefined && onClick !== undefined;
  return (
    <TextFlexRowWithChildren isTruncated={isTruncated} bold={bold} text={text}>
      {isButtonShowing && (
        <Button
          onClick={onClick}
          variant="tertiary"
          fontWeight="normal"
          textDecor="underline"
          size="sm"
          color="primary.350"
          h="24px"
          data-testid="text-row-button"
          aria-label={ariaLabel}
        >
          {buttonText}
        </Button>
      )}
    </TextFlexRowWithChildren>
  );
};
